import { useQuery } from '@tanstack/react-query';
import { TEMPLATE_REGISTRY } from './templates/index';

const DEFAULT_SECTIONS = [
  { templateId: 'hero-slider',       props: {} },
  { templateId: 'category-grid',     props: {} },
  { templateId: 'shop-by-age',       props: {} },
  { templateId: 'featured-products', props: { title: 'Best Sellers ⭐' } },
  { templateId: 'banner',            props: {} },
  { templateId: 'testimonials',      props: {} },
  { templateId: 'newsletter',        props: {} },
];

async function fetchSections(postId) {
  const apiUrl = (window.themeData?.apiUrl ?? '').replace(/\/$/, '');
  const res = await fetch(`${apiUrl}/anvi/v1/page-sections/${postId}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

function SectionSkeleton() {
  return (
    <div className="py-8 px-4 space-y-6 max-w-7xl mx-auto">
      {[1, 2, 3].map((i) => (
        <div key={i} className="h-48 bg-gray-100 animate-pulse rounded-2xl" />
      ))}
    </div>
  );
}

export default function PageRenderer({ postId }) {
  const { data, isLoading } = useQuery({
    queryKey: ['page-sections', postId],
    queryFn: () => fetchSections(postId),
    enabled: !!postId,
    retry: false,
    staleTime: 60_000,
  });

  if (isLoading) return <SectionSkeleton />;

  // postId=0 means the front page (blog index) — use the default homepage layout.
  // Any real page/post with no saved sections renders nothing (WP handles its own content).
  const sections = postId === 0 ? DEFAULT_SECTIONS : (data?.sections ?? []);

  return (
    <>
      {sections.map((sec, idx) => {
        const template = TEMPLATE_REGISTRY.find((t) => t.id === sec.templateId);
        if (!template?.component) return null;
        const Component = template.component;
        return (
          <Component
            key={`${sec.templateId}-${idx}`}
            {...(template.defaultProps ?? {})}
            {...(sec.props ?? {})}
          />
        );
      })}
    </>
  );
}
